 document.addEventListener('DOMContentLoaded', function() {
                    const selector = document.querySelector('.pack-selector');
                    if (!selector) return;

                    const root = selector.closest('.product-info') || document;
                    const mainForm = root.querySelector('form[data-type="add-to-cart-form"]');
                    if (!mainForm) return;

                    const sectionId = selector.dataset.sectionId;
                    if (!sectionId) return;
                    const stickyRoot = document.querySelector('#sticky-add-to-cart-' + sectionId);
                    const stickyForm = stickyRoot ? stickyRoot.querySelector('form[data-type="add-to-cart-form"]') : null;

                    let mainQtyInput = mainForm.querySelector('input[name="quantity"]');

                    if (!mainQtyInput) {
                      mainQtyInput = document.createElement('input');
                      mainQtyInput.type = 'hidden';
                      mainQtyInput.name = 'quantity';
                      mainQtyInput.value = '1';
                      mainQtyInput.id = 'pack-quantity';
                      mainForm.appendChild(mainQtyInput);
                    }

                    function ensureStickyQtyInput() {
                      if (!stickyForm) return null;

                      let stickyQtyInput = stickyForm.querySelector('input[name="quantity"]');

                      if (!stickyQtyInput) {
                        stickyQtyInput = document.createElement('input');
                        stickyQtyInput.type = 'hidden';
                        stickyQtyInput.name = 'quantity';
                        stickyQtyInput.value = '1';
                        stickyQtyInput.id = 'pack-quantity-sticky-' + sectionId;
                        stickyForm.appendChild(stickyQtyInput);
                      }

                      return stickyQtyInput;
                    }

                    const packs = selector.querySelectorAll('.pack-card');
                    if (!packs.length) return;

                    function updateDisplayedPrice(wrapper, price, compare) {
                      if (!wrapper) return;

                      const priceSpan = wrapper.querySelector('.price span');
                      if (priceSpan) {
                        priceSpan.textContent = price || '';
                      }

                      const saleSpan = wrapper.querySelector('.price-sale');
                      if (saleSpan) {
                        saleSpan.textContent = price || '';
                      }

                      const compareTarget = wrapper.querySelector('.target-compare-at-price');
                      if (compareTarget) {
                        compareTarget.textContent = compare || '';
                      }

                      const compareVisible = wrapper.querySelector('.price-compare, s');
                      if (compareVisible) {
                        compareVisible.textContent = compare || '';
                        compareVisible.style.display = compare ? '' : 'none';
                      }
                    }

                    function syncStickyPrice(price, compare) {
                      if (!stickyRoot) return;

                      const stickyPriceAreas = stickyRoot.querySelectorAll('.pricearea');

                      stickyPriceAreas.forEach(function(priceArea) {
                        const allTextTargets = priceArea.querySelectorAll(
                          '.price span, .price-sale, .main-product-price .price, .main-product-price .price span'
                        );

                        allTextTargets.forEach(function(el) {
                          el.textContent = price || '';
                        });

                        const compareTargets = priceArea.querySelectorAll(
                          '.price-compare, .target-compare-at-price, s'
                        );

                        compareTargets.forEach(function(el) {
                          el.textContent = compare || '';
                          el.style.display = compare ? '' : 'none';
                        });
                      });
                    }

                    function syncStickyQuantity(qty) {
                      if (!stickyRoot) return;

                      const stickyQtyInput = ensureStickyQtyInput();

                      if (stickyQtyInput) {
                        stickyQtyInput.value = qty;
                        stickyQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
                        stickyQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
                      }

                      const visibleStickyQty = stickyRoot.querySelector('#Quantity-sticky-' + sectionId);

                      if (visibleStickyQty) {
                        visibleStickyQty.value = qty;
                        visibleStickyQty.dispatchEvent(new Event('input', { bubbles: true }));
                        visibleStickyQty.dispatchEvent(new Event('change', { bubbles: true }));
                      }

                      document.dispatchEvent(new CustomEvent('eurus:product:quantity-changed-' + sectionId, {
                        detail: {
                          quantity: qty
                        }
                      }));
                    }

                    function syncStickyVariantId() {
                      if (!stickyRoot) return;

                      const mainVariantInput = mainForm.querySelector('input[name="id"]');
                      const stickyVariantInput = stickyRoot.querySelector('#update-variant-sticky-' + sectionId);

                      if (!mainVariantInput || !stickyVariantInput) return;

                      stickyVariantInput.value = mainVariantInput.value;

                      stickyVariantInput.dispatchEvent(new Event('input', { bubbles: true }));
                      stickyVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    function syncStickyText(title, subtitle) {
                      if (!stickyRoot) return;

                      const titleEl = stickyRoot.querySelector('.sticky-product-title');

                      if (titleEl) {
                        titleEl.textContent = title || '{{ product.title | escape }}';
                      }
                    }
                    function applyPack(pack) {
                      if (!pack) return;
                      packs.forEach(function(item) {
                        item.classList.remove('active');
                      });
                      pack.classList.add('active');
                      const title = pack.getAttribute('data-title') || '';
                      const subtitle = pack.getAttribute('data-subtitle') || '';
                      const qty = pack.getAttribute('data-qty') || '1';
                      const price = pack.getAttribute('data-price') || '';
                      const compare = pack.getAttribute('data-compare') || '';

                      mainQtyInput.value = qty;
                      mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
                      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));

                      const mainPriceWrappers = root.querySelectorAll('.pricearea .main-product-price');
                      mainPriceWrappers.forEach(function(wrapper) {
                        updateDisplayedPrice(wrapper, price, compare);
                      });

                      const buttonPriceWrapper = mainForm.querySelector('.x-atc-text .main-product-price');
                      updateDisplayedPrice(buttonPriceWrapper, price, compare);

                      syncStickyQuantity(qty);
                      syncStickyVariantId();
                      syncStickyText(title, subtitle);
                      syncStickyPrice(price, compare);
                    }

                    packs.forEach(function(pack) {
                      pack.addEventListener('click', function() {
                        applyPack(pack);
                      });
                    });

                    document.addEventListener('change', function(event) {
                      if (!event.target.matches('input[name="id"], select[name]')) return;

                      setTimeout(function() {
                        const activePack = selector.querySelector('.pack-card.active') || packs[0];
                        applyPack(activePack);
                      }, 80);
                    });

                    const initiallyActivePack = selector.querySelector('.pack-card.active') || packs[0];
                    applyPack(initiallyActivePack);
                  });